// extracted by mini-css-extract-plugin
export var divider = "_d0-7";
export var itemsToggle = "_d0-8";
export var mergeModal = "_d0-1";
export var optionCard = "_d0-4";
export var radioGroup = "_d0-6";
export var radioOption = "_d0-0";
export var selected = "_d0-5";
export var shipmentOptions = "_d0-2";
export var tableOptions = "_d0-3";